import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { repairBodyScrollIfLeaked } from '../utils/bodyScrollLock';

/**
 * After SPA navigations, clear leaked `overflow: hidden` when no lock is held.
 * Does not force-unlock while a modal/drawer still owns a lock.
 */
export function BodyScrollRepair(): null {
  const location = useLocation();

  useEffect(() => {
    repairBodyScrollIfLeaked();
  }, [location.pathname, location.search]);

  return null;
}
